import React, { useEffect, useState } from 'react'
import { LeasesBasicDetails, LeasesNav } from '../../elements';
import { Box, Button, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, Typography } from '@mui/material';
import { NoRecordFound, PageLoader, STableLoader } from '../../../shared_elements';
import { globalGetService } from '../../../utils/globalApiServices';
import { getUpcomingEventsListApi } from '../apiService';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { assetType } from '../../../constants';
import { checkApiStatus } from '../../../utils';
import UpComingEventsList from '../components/upComingEventsList';
import { trackActivity } from '../../../utils/mixpanel';
import ModuleNotExcessModal from '../../../shared_elements/components/ModuleNotExcessModal';
import { ButtonLoader } from '../../../shared_elements/components';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import BackToLeaseList from '../../elements/BackToLeaseList';
import { enqueueSnackbar } from 'notistack';

const UpcomingEventsHD = ({sortInfo,createSortHandler,handleItemClicked}) => {
  return (
    < TableHead >

      < TableRow className="uet-group-row">
        <TableCell sx={{border:'none !important'}} ></TableCell>
        <TableCell align="center" colSpan={4} className="uet-lsv-group">
          <strong>Last Shop Visit</strong>
        </TableCell>
        <TableCell align="center" colSpan={4} className="uet-nsv-group">
          <strong>Next Shop Visit</strong>
        </TableCell>
        <TableCell colSpan={2} sx={{border:'none !important'}} ></TableCell>
      </ TableRow>
      <TableRow TableRow className="uet-sub-row">
        <TableCell sx={{ minWidth: '180px' }}>
           <TableSortLabel
                active={sortInfo?.sort_by === 'order' ? true : false}
                direction={sortInfo?.sort_by === 'order' ? sortInfo?.sort : 'asc'}
                onClick={() => { createSortHandler('order'); handleItemClicked?.('Table Sorting: Event'); }}
            >
                Event
            </TableSortLabel></TableCell>
        <TableCell className="uet-lsv-start">Date</TableCell>
        <TableCell >TSN</TableCell>
        <TableCell >CSN</TableCell>
        <TableCell className="uet-lsv-end">Cost</TableCell>

        <TableCell className="uet-nsv-start">Date</TableCell>
        <TableCell >TSN</TableCell>
        <TableCell >CSN</TableCell>
        <TableCell className="uet-nsv-end">Cost</TableCell>

        <TableCell sx={{maxWidth:'100px'}}>Interval</TableCell>
        <TableCell sx={{maxWidth:'120px'}}>Notes</TableCell>
      </TableRow >

    </TableHead >


  )
}

const UpcomingEvents = () => {
  const params = useParams();
  const [upComingEventInfo, setUpComingEventInfo] = useState({ list: [], pagination: null });
  const { leaseBasicDetails } = useSelector((state) => state.leases);
  const [skeletonLoader, setSkeletonLoader] = useState(!Boolean(leaseBasicDetails?.asset))
  const [isExport, setExport] = useState(false);
  const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
  const [isLoading,setLoading] =useState(false);

  const assetTypeMap = {
    1: "aircraft",
    2: "engine",
    3: "apu",
    4: "lg",
    5: "propeller",
    6: "fan",
    7: "hpc",
    8: "hpt",
    9: "lpt",
    10: "component"
  };


  useEffect(() => {
    if (!leaseBasicDetails) return;
    if (leaseBasicDetails?.status === 'Draft') return;
    if (leaseBasicDetails?.asset) getUpComingEventsList('skeletonLoader');
  }, [leaseBasicDetails]);

  useEffect(() => {
    trackActivity('Page Viewed', { page_title: 'Upcoming Events' })
  }, []);

  const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: 'Upcoming Events', page_type: page_type })
  }

  const getUpComingEventsList = (loaderType,query={}) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
    globalGetService(getUpcomingEventsListApi(query,params?.leaseSlug, assetType[leaseBasicDetails?.asset?.asset_type], leaseBasicDetails?.asset?.id)).then(response => {
      if (checkApiStatus) {
        setUpComingEventInfo(response?.data?.data);
        loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
      }
    })
  }

  const createSortHandler = (key) => {
        let sortQuery = { sort_by: key };
        if (sortInfo.sort_by === key) {
            sortQuery = { ...sortQuery, sort: sortInfo.sort === 'asc' ? 'desc' : 'asc' }
        } else {
            sortQuery = { ...sortQuery, sort: 'asc' }
        }
        setSortInfo(sortQuery)
        getUpComingEventsList('',{ [key]:sortQuery.sort,event_order:'asc'});
    }

 
  const handleExport = () => {
          let query = { export: true }
          if (sortInfo?.sort && sortInfo?.sort_by) {
              query = {
                  ...query,
                  [sortInfo?.sort]: sortInfo?.sort_by,
                  event_order:'asc'
              }
          }
          setExport(true);
          globalGetService(getUpcomingEventsListApi(query,params?.leaseSlug, assetType[leaseBasicDetails?.asset?.asset_type], leaseBasicDetails?.asset?.id)).then((response) => {
              if (checkApiStatus(response)) {
                  enqueueSnackbar(
                      response?.data.message,
                      { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } }
                  );
                  setExport(false);
              }
          })
      }
  return (
    <>
      <LeasesBasicDetails />
      <Paper className='lease-details-section lease-nav-module-margin lease-module-paper' elevation={0}>
        <LeasesNav />
        {leaseBasicDetails?.status === 'Draft' ? (<ModuleNotExcessModal moduleName="Upcoming Events" />) : leaseBasicDetails && Object.keys(leaseBasicDetails).length > 0 && !leaseBasicDetails?.status ? (<ModuleNotExcessModal leaseNotFound />) :
          <div className='lease-details-content'>
            <Paper square className="responsive-paper" sx={{ marginBottom: '10px' }}>
              <Grid container spacing={1} className="responsive-grid" alignItems='end'>
                <Grid item size={{ md: 4, xs: 12 }} className="menu-container">
                  <BackToLeaseList/>
                </Grid>
                <Grid item size={{ md: 8, xs: 12 }} className="menu-container">
                  <ul className='list-inline lease-details-right-items lease-details-btn' style={{padding:'0px',float:'right',minHeight:'35px'}}>
                    {upComingEventInfo?.assemblies?.length > 0 ? <li className='lease-mobile-button'><Button startIcon={isExport ? <ButtonLoader size={15} /> : <ArrowDownwardIcon />} onClick={() => { handleExport(); handleItemClicked('Export Button') }} variant="outlined" size='small' className='btn-primary action-btn-start-icon' sx={{top: "5px"}}> Export </Button> </li> : null}
                  </ul>
                </Grid>
              </Grid>
            </Paper>
            <Paper className='lease-detail-table' square>
              {skeletonLoader ? <STableLoader count={4}  rowCount={11}/> : (<>
                <TableContainer component={Paper} className='uce-container upcoming-events-table' >
                  <Table className="uet-table" stickyHeader>
                    <UpcomingEventsHD createSortHandler={createSortHandler} sortInfo={sortInfo} handleItemClicked={handleItemClicked}/>
                      {upComingEventInfo?.assemblies?.length > 0 && upComingEventInfo.assemblies.some(a => a?.events?.length > 0) ? (
                    <TableBody>
                        {upComingEventInfo.assemblies.map((eventsInfo, index) =>
                          eventsInfo?.events?.length > 0
                            ? eventsInfo.events.map((item, i) => (
                                <UpComingEventsList key={`${index}-${i}`} item={item} eventsInfo={eventsInfo} />
                              ))
                            : null
                        )}
                    </TableBody>
                      ) :   <TableRow > <TableCell colSpan={20} sx={{ textAlign:"center", height: "30px" }} > No record found </TableCell> </TableRow>}

                  </Table>
                </TableContainer>
              </>)}
            </Paper>
          </div>}
      </Paper>
      {isLoading ? <PageLoader /> : null}
    </>
  )
}
export default UpcomingEvents;